import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/api/client";
import { AuthCard } from "@/components/auth/AuthCard";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    setIsLoading(true);
    try {
      const result = await api.forgotPassword(email);
      setSuccess(result.message ?? "If this email exists, a reset link has been sent.");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Request failed");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthCard
      title="EVzone Media & Content Platform"
      subtitle="Reset your password"
      footer={
        <>
          Remember your password? <Link to="/auth/login">Sign in</Link>
        </>
      }
    >
      <form onSubmit={handleSubmit} className="ev-login__form">
        <label className="ev-login__field">
          <span>Email</span>
          <input
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={isLoading}
            required
          />
        </label>
        {error && <div className="ev-login__error" role="alert">{error}</div>}
        {success && <div className="ev-login__success" role="status">{success}</div>}
        <button type="submit" className="ev-login__submit" disabled={isLoading}>
          {isLoading ? "Sending…" : "Send reset link"}
        </button>
      </form>
    </AuthCard>
  );
}
